import { objectIsEmpty } from 'shared/utils/objectHelper';
import { IOrder } from 'Order/types/store';
import { location } from 'Order/types/location';

export const isEmptyLocation = (order: IOrder, loc: location): boolean => {
  const { siteContact, endCompanyName } = order[loc];

  return objectIsEmpty(siteContact) && !endCompanyName;
};
